import Vue from 'vue'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { TextTemplateRelationShipOntologyResponseList, TextTemplatesRelationShipOntologyCreateRequest } from './text-templates.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class TextTemplatesConfigurationOntologyRelationshipServices extends Vue {
    async getTextTemplatesRelationshipOntologies(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<TextTemplateRelationShipOntologyResponseList>> {
        const response = await this.axios.put(`/configuration/laboratories/${laboratoryId}/textTemplateOntologies`, { ...filterModel }, { params })
        return response.data
    }
    async createTextTemplatesRelationshipOntologies(request: TextTemplatesRelationShipOntologyCreateRequest, laboratoryId: number): Promise<TextTemplateRelationShipOntologyResponseList> {
        const response = await this.axios.post(`/configuration/laboratories/${laboratoryId}/textTemplateOntologies`, request)
        return response.data
    }
    async deleteTextTemplatesRelationshipOntologies(textTemplateOntologyId :number, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete(`/configuration/laboratories/${laboratoryId}/textTemplateOntologies/${textTemplateOntologyId}`)
        return response.data
    }
}

export const textTemplatesConfigurationOntologyRelationshipServices = new TextTemplatesConfigurationOntologyRelationshipServices()
